import { createContext, useContext } from 'react'

import { ResidentLedger, ResidentTenancy } from '../_types/resident'

interface ResidentTenancyContextValue {
  tenancies: ResidentTenancy[]
  isLoadingTenancies: boolean
  hasResidentAccess: boolean
  selectedTenancyId: string
  selectedTenancy: ResidentTenancy | null
  selectTenancy: (tenancyId: string) => void
  refreshTenancies: () => Promise<void>
  ledger: ResidentLedger | null
  isLoadingLedger: boolean
}

const ResidentTenancyContext =
  createContext<ResidentTenancyContextValue | null>(null)

/**
 * Reads the renter's resident-portal state — their tenancies, the selected
 * tenancy, that tenancy's ledger, and a tenancy refresher — shared across the
 * Home / Payments / Maintenance surfaces. Throws outside the provider.
 *
 * @returns {ResidentTenancyContextValue}
 */
const useResidentTenancy = (): ResidentTenancyContextValue => {
  const context = useContext(ResidentTenancyContext)
  if (context === null) {
    throw new Error(
      'useResidentTenancy must be used within a ResidentTenancyProvider',
    )
  }
  return context
}

export {
  ResidentTenancyContext,
  type ResidentTenancyContextValue,
  useResidentTenancy,
}
